"use client";

import React from "react";
import useToastStore from "./useToastStore";
import { cn } from "@khol/utils/tailwind/cn";
import { Toast } from "@khol/ui/Toast";

export default function ToastTray() {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.remove);

  return (
    <div
      className={cn(
        "fixed right-0 top-16 z-[9999] flex max-w-sm flex-col gap-4",
        { "m-4": toasts.length > 0 },
      )}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          title={toast.title ?? ""}
          description={toast.description}
          htmlContent={toast.htmlContent}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}
